function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

export function deleteObjectProperty(obj, keys) {
  var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  if (obj == null || _typeof(obj) !== 'object') {
    return false;
  }

  for (var i = index; i < keys.length - 1; i++) {
    obj = obj[keys[i]];

    if (obj == null || _typeof(obj) !== 'object') {
      return false;
    }
  }

  delete obj[keys[keys.length - 1]];
  return true;
}